<template>
  <div v-if="!!info" class="map">
    <!-- <button type="button" class="btn btnWhite direction" @click.stop="getDirection">길찾기</button> -->
    <GmapMap
      :center="{
        lat: location.lat,
        lng: location.lng
      }"
      :zoom="zoom"
      ref="map"
      style="width: 100%; height: 100%">
      <GmapMarker
        :position="{
          lat: location.lat,
          lng: location.lng
        }"
        :icon="{
          url: iconUrl.place,
          scaledSize: iconSize
        }" />
      <GmapMarker
        :position="{
          lat: from.lat,
          lng: from.lng
        }"
        :icon="{
          url: iconUrl.hotel,
          scaledSize: iconSize
        }" />
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: 'LocalMap',
  props: [
    'info'
  ],
  computed: {
    location () {
      return this.info.location
    },
    from () {
      return this.info.from
    },
    direction () {
      return {
        from: {
          lat: this.from.lat,
          lng: this.from.lng
        },
        to: {
          lat: this.location.lat,
          lng: this.location.lng
        }
      }
    },
    zoom () {
      const distance = this.info.distance
      const term = parseInt(distance / 100)
      function distanceToZoom (d) {
        if (d < 5) {
          return 16
        } else if (d < 10) {
          return 15
        } else if (d < 16) {
          return 14
        } else if (d < 30) {
          return 13
        } else {
          return 12
        }
      }
      return distanceToZoom(term)
    }
  },
  mounted () {
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
    /*
    const location = this.location
    this.$refs.map.$mapPromise.then((map) => {
      map.panTo({
        lat: location.lat,
        lng: location.lng
      })
     console.log(map)
    })
    */
  },
  data () {
    return {
      iconUrl: {
        place: require('@/assets/img/location_place.svg'),
        hotel: require('@/assets/img/location_hotel.svg')
      },
      iconSize: {
        width: 45,
        height: 45
      },
      icon: {
        scaledSize: {
          width: 45,
          height: 45
        }
      },
      coords: {
        lat: -7.824374,
        lng: 110.262371
      },
      destination: {
        lat: -7.925665,
        lng: 110.298115
      }
    }
  },
  methods: {
    getDirection: function () {
      var directionsService = new google.maps.DirectionsService
      var directionsDisplay = new google.maps.DirectionsRenderer
      directionsDisplay.setMap(this.$refs.map.$mapObject)
      // google maps API's direction service
      function calculateAndDisplayRoute (directionsService, directionsDisplay, start, destination) {
        directionsService.route({
          origin: start,
          destination: destination,
          travelMode: 'WALKING'
        }, function (response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response)
          } else {
            window.alert('Directions request failed due to ' + status)
          }
        })
      }
      calculateAndDisplayRoute(directionsService, directionsDisplay, this.direction.from, this.direction.to)
    }
  }
}
</script>

<style lang="scss" scoped>
.direction {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 9;
}
</style>
